import { t } from 'i18next';
import { useRevealOnScroll } from 'src/shared';

export default function OrganiserStripComponent() {
  const ref = useRevealOnScroll<HTMLDivElement>();
  return (
    <div ref={ref} className="org reveal" id="organisers">
      <div>
        <span className="eyebrow"><span className="dot" />{t('joinPage.v2.organiserStrip.eyebrow')}</span>
        <h3>{t('joinPage.v2.organiserStrip.headline')}</h3>
        <p>{t('joinPage.v2.organiserStrip.body')}</p>
      </div>
      <a className="btn btn--primary" href="https://superfans.social" target="_blank" rel="noopener noreferrer">
        {t('joinPage.v2.organiserStrip.cta')} <span className="arr">→</span>
      </a>
    </div>
  );
}
